const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const { logError } = require('../../logger');

const ArrowShot = function (battleState) {
  this.handle = 'arrow_shot';
  this.physical = true;
  this.bow = true;
  this.ranged = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return (
      victim.unit &&
      actor.equipment.off_hand &&
      actor.equipment.off_hand.type === 'bow'
    );
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    setTimeout(() => {
      try {
        if (
          !actor ||
          !actor.inPlay ||
          !victim ||
          (victim.unit && !victim.inPlay)
        ) {
          return;
        }

        const result = this.standardStrike.execute(
          actor,
          victim,
          BattleCalc.getEquippedAbility(actor, 'arrow_shot').damage,
          true
        );
        result.abilityHandle = this.handle;
        result.actorId = actor.uid;
        result.victimId = victim.uid;

        this.eventEmitter.emit('result', result);
      } catch (err) {
        logError(err, {
          module: 'ArrowShot',
          func: 'execute',
          actor,
          victim,
        });
      }
    }, BattleCalc.projectileTime(BattleConfig.ARROW_SPEED, actor, victim));
  };
};
module.exports = ArrowShot;
